import { AnimationContent } from "./AnimationContent";
import { AnimationNodeContent } from "./AnimationNodeContent";
import { KeyFramesContent } from "./KeyFramesContent";
import { IAniLib } from "./AniLibPack";
import { Byte } from "../utils/Byte";
export class AnimationParser01 {
    static parse(templet, reader) {
        var data = reader.rawBuffer;
        var i, j, k, n, l, m, o;
        var aniClassName = reader.readUTFString();
        templet._aniClassName = aniClassName;
        var strList = reader.readUTFString().split("\n");
        var aniCount = reader.readUint8();
        var publicDataPos = reader.readUint32();
        var publicExtDataPos = reader.readUint32();
        var publicData;
        if (publicDataPos > 0)
            publicData = data.slice(publicDataPos, publicExtDataPos);
        var publicRead = new Byte(publicData);
        if (publicExtDataPos > 0)
            templet._publicExtData = data.slice(publicExtDataPos, data.byteLength);
        templet._useParent = !!reader.readUint8();
        templet._anis.length = aniCount;
        for (i = 0; i < aniCount; i++) {
            var ani = templet._anis[i] = new AnimationContent();
            ani.nodes = [];
            var name = ani.name = strList[reader.readUint16()];
            templet._aniMap[name] = i;
            ani.bone3DMap = {};
            ani.playTime = reader.readFloat32();
            var boneCount = ani.nodes.length = reader.readUint8();
            ani.totalKeyframeDatasLength = 0;
            for (j = 0; j < boneCount; j++) {
                var node = ani.nodes[j] = new AnimationNodeContent();
                node.childs = [];
                var nameIndex = reader.readInt16();
                if (nameIndex >= 0) {
                    node.name = strList[nameIndex];
                    ani.bone3DMap[node.name] = j;
                }
                node.keyFrame = [];
                node.parentIndex = reader.readInt16();
                node.parentIndex == -1 ? node.parent = null : node.parent = ani.nodes[node.parentIndex];
                node.lerpType = reader.readUint8();
                var keyframeParamsOffset = reader.readUint32();
                publicRead.pos = keyframeParamsOffset;
                var keyframeDataCount = node.keyframeWidth = publicRead.readUint16();
                ani.totalKeyframeDatasLength += keyframeDataCount;
                if (node.lerpType === 0 || node.lerpType === 1) {
                    node.interpolationMethod = [];
                    node.interpolationMethod.length = keyframeDataCount;
                    for (k = 0; k < keyframeDataCount; k++)
                        node.interpolationMethod[k] = IAniLib.AnimationTemplet.interpolation[publicRead.readUint8()];
                }
                if (node.parent != null)
                    node.parent.childs.push(node);
                var privateDataLen = reader.readUint16();
                if (privateDataLen > 0) {
                    node.extenData = data.slice(reader.pos, reader.pos + privateDataLen);
                    reader.pos += privateDataLen;
                }
                var keyframeCount = reader.readUint16();
                node.keyFrame.length = keyframeCount;
                var startTime = 0;
                var keyFrame;
                for (k = 0, n = keyframeCount; k < n; k++) {
                    keyFrame = node.keyFrame[k] = new KeyFramesContent();
                    keyFrame.duration = reader.readFloat32();
                    keyFrame.startTime = startTime;
                    if (node.lerpType === 2) {
                        keyFrame.interpolationData = [];
                        var interDataLength = reader.readUint8();
                        var lerpType;
                        lerpType = reader.readFloat32();
                        switch (lerpType) {
                            case 254:
                                keyFrame.interpolationData.length = keyframeDataCount;
                                for (o = 0; o < keyframeDataCount; o++)
                                    keyFrame.interpolationData[o] = 0;
                                break;
                            case 255:
                                keyFrame.interpolationData.length = keyframeDataCount;
                                for (o = 0; o < keyframeDataCount; o++)
                                    keyFrame.interpolationData[o] = 5;
                                break;
                            default:
                                keyFrame.interpolationData.push(lerpType);
                                for (m = 1; m < interDataLength; m++) {
                                    keyFrame.interpolationData.push(reader.readFloat32());
                                }
                        }
                    }
                    keyFrame.data = new Float32Array(keyframeDataCount);
                    keyFrame.dData = new Float32Array(keyframeDataCount);
                    keyFrame.nextData = new Float32Array(keyframeDataCount);
                    for (l = 0; l < keyframeDataCount; l++) {
                        keyFrame.data[l] = reader.readFloat32();
                        if (keyFrame.data[l] > -0.00000001 && keyFrame.data[l] < 0.00000001)
                            keyFrame.data[l] = 0;
                    }
                    startTime += keyFrame.duration;
                }
                keyFrame.startTime = ani.playTime;
                node.playTime = ani.playTime;
                templet._calculateKeyFrame(node, keyframeCount, keyframeDataCount);
            }
        }
    }
}
